const mutationCreator = ( mutation) => {

  const createInput = (properties) => {
    return properties.map((x) => {
      return `${x.propertyName}: $${x.propertyName}`
    }).join(", ")
  }
  const createVariable = (properties) => {
    return properties.map((x) => {
      return `$${x.propertyName}: ${x.dataType}!`
    }).join(", ")
  }
  const variables = createVariable(mutation.definitions);
  const input = createInput(mutation.definitions);    
  const CREATE_MUTATION = `
    mutation ${mutation.typeName}(${variables}){ 
   ${mutation.typeName}(input:  {${input}})
   {
     isSuccess
     message
     value{
       id
       displayName
     }
   }
 }`;

  return CREATE_MUTATION
}

export default mutationCreator;
